import React from "react";
import {
    View,
    Text,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";
import PendingVote from "./Pending_Icon.svg";

const styles = StyleSheet.create({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    icon: {
        marginRight: "3px",
    },
    text: {
        fontSize: "8px",
        color: "#243746",
        fontWeight: "bold",
    },
    image: {
        width: 20,
        height: 20,
        marginLeft: "-1px",
    },
});

const Icon = () => (
    <Image src={PendingVote} style={styles.image} />
)

const PendingIcon = () => (
    <View style={styles.container} >
        <View style={styles.icon}>
            <Icon />
        </View>
        <Text style={styles.text}>Voting in Progress</Text>
    </View>
);

export default PendingIcon;
